module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "myRegister-myRegister"
    }
  }, [_c('section', {
    staticClass: "thick"
  }, [_c('hospital-select', {
    on: {
      "selected": _vm.selectHospital
    }
  }), _vm._v(" "), _c('voucher-select', {
    attrs: {
      "list": _vm.voucherList
    },
    on: {
      "selected": _vm.selectVoucher
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "query-more"
  }, [_c('span', [_vm._v("此处展示近三个月的历史记录")]), _vm._v(" "), _c('button', {
    staticClass: "btn-ok",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._v("更多")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isChoose),
      expression: "isChoose"
    }],
    staticClass: "query-history"
  }, [_c('div', {
    staticClass: "time"
  }, [_vm._v("请选择查询时间段")]), _vm._v(" "), _c('div', {
    staticClass: "history-more"
  }, [_c('div', {
    staticClass: "option",
    attrs: {
      "id": "StartDate"
    },
    on: {
      "click": _vm.setStartDate
    }
  }, [_vm._v("\n        " + _vm._s(_vm.startDate) + "\n      ")]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', {
    staticClass: "option",
    attrs: {
      "id": "EndDate"
    },
    on: {
      "click": _vm.setEndDate
    }
  }, [_vm._v(_vm._s(_vm.endDate))]), _vm._v(" "), _c('button', {
    staticClass: "btn-ok",
    on: {
      "click": function($event) {
        return _vm.chooseNewDate()
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('scroll', {
    staticClass: "from-query-more",
    attrs: {
      "id": "my-register-scroll"
    },
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('no-record', {
    attrs: {
      "id": "myregister-norecord",
      "condition": _vm.regList,
      "tips": "抱歉，没有挂号记录"
    }
  }), _vm._v(" "), _vm._l((_vm.regList), function(reg, index) {
    return _c('section', {
      staticClass: "thick",
      attrs: {
        "id": 'myregister-list-' + index
      },
      on: {
        "click": function($event) {
          return _vm.goRegDetail(reg)
        }
      }
    }, [_c('div', {
      staticClass: "panel ellipsis"
    }, [_vm._v("\n        " + _vm._s(reg.deptName) + "  " + _vm._s(reg.doctName) + "  " + _vm._s(_vm._f("formatBracket")(reg.rankName)) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "content arr-row f-minor"
    }, [_c('span', [_vm._v("挂号时间")]), _vm._v("    "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(reg.orderTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("就诊时间")]), _vm._v("    "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(reg.visitTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom",
      staticStyle: {
        "text-align": "right"
      }
    }, [(
      reg.regStatus === 4 &&
      (reg.orderStatus === 1 || reg.orderStatus === 2)
    ) ? _c('span', {
      staticClass: "order-status f-minor"
    }, [_vm._v("已预约")]) : _vm._e(), _vm._v(" "), (reg.regStatus === 5) ? _c('span', {
      staticClass: "order-status f-minor"
    }, [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (reg.orderStatus === 3) ? _c('span', {
      staticClass: "order-status f-minor"
    }, [_vm._v("已支付")]) : _vm._e(), _vm._v(" "), (reg.orderStatus === 4) ? _c('span', {
      staticClass: "order-status f-strong"
    }, [_vm._v("已支付")]) : _vm._e(), _vm._v(" "), (reg.orderStatus === 5) ? _c('span', {
      staticClass: "order-status f-minor"
    }, [_vm._v("已退号")]) : _vm._e(), _vm._v(" "), (reg.orderStatus === 6) ? _c('span', {
      staticClass: "order-status f-minor"
    }, [_vm._v("已退号")]) : _vm._e(), _vm._v(" "), (
      (reg.orderStatus === 2 || reg.orderStatus === 1) &&
      reg.regStatus != 5
    ) ? _c('button', {
      staticClass: "btn-minor-red",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(reg, index, 'cancel')
        }
      }
    }, [_vm._v("\n          取消\n        ")]) : _vm._e(), _vm._v(" "), (reg.orderStatus === 2 && reg.regStatus === 4) ? _c('button', {
      staticClass: "btn-minor-orange",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goPay(reg)
        }
      }
    }, [_vm._v("\n          缴费\n        ")]) : _vm._e(), _vm._v(" "), (reg.orderStatus === 4) ? _c('button', {
      staticClass: "btn-minor-orange",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(reg, index, 'fade')
        }
      }
    }, [_vm._v("\n          退号\n        ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('confirm', {
    attrs: {
      "text": _vm.confirmMsg
    },
    on: {
      "on-sure": _vm.confirm
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  }), _vm._v(" "), _c('payConfirm', {
    model: {
      value: (_vm.showPayConfirm),
      callback: function($$v) {
        _vm.showPayConfirm = $$v
      },
      expression: "showPayConfirm"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b856da9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/myregister/MyRegister.vue
// module id = 816
// module chunks = 0